import { render } from "./QuestionObjectPhonemicConsonant.vue?vue&type=template&id=0f1cefe0&scoped=true"
import script from "./QuestionObjectPhonemicConsonant.vue?vue&type=script&lang=js"
export * from "./QuestionObjectPhonemicConsonant.vue?vue&type=script&lang=js"

import "@/css/components/question-object-phonemic-consonant.css?vue&type=style&index=0&id=0f1cefe0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1cefe0"]])

export default __exports__